konnyScript(function($){
    var swiper = new Swiper("#hip_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        centeredSlides:true,
        loop: false,
        scrollbar: {
            el: '#hip_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#hip_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#hip_swiper_slide1 .swiper-button-next',
            prevEl: '#hip_swiper_slide1 .swiper-button-prev',
        },
    });
});